module.exports = __webpack_public_path__ + "static/img/userule1.96753f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userule1.jpg
// module id = bvH+
// module chunks = 0